import React, { useEffect, useState } from 'react'
import type { PageTheme } from '../typeScript/types/PageTheme'
import Notification from './Notification'
import Button from './Button'
import { ButtonType } from 'typeScript/types/ButtonTypes'
import ButtonTooltip from './ButtonTooltip'

interface HeaderButtonProps {
  readonly label: string
  readonly onClick: () => void
  readonly disabled?: boolean
  readonly title?: string
}

type Prop = {
  title?: string
  intro?: string
  className?: string
  notificationText?: string
  withAnimation?: boolean
  children?: React.ReactNode
  gradientClassName?: string
  pageTheme?: PageTheme
  headerButton?: HeaderButtonProps
}

const Page = (props: Prop) => {
  const {
    title,
    intro,
    className,
    withAnimation = true,
    notificationText = false,
    pageTheme,
    headerButton,
  } = props
  const [paddingTop, setPaddingTop] = useState<number>()
  const navHeight = 74

  useEffect(() => {
    if (notificationText) {
      const notification = document.querySelector('.notification')
      const oldNotificationHeight = notification && notification.clientHeight

      oldNotificationHeight && notificationText
        ? setPaddingTop(oldNotificationHeight + navHeight)
        : setPaddingTop(navHeight)
    }
  }, [notificationText])

  return (
    <div
      // TODO::: container mx-auto px-4
      className={`page ${pageTheme && pageTheme} ${
        withAnimation && 'page__animation'
      } ${className} `}
      style={{
        paddingTop: paddingTop && paddingTop,
      }}
    >
      {notificationText && <Notification text={notificationText} />}
      {title && (
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-5">
          <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
          <div className="flex items-center gap-2">
            {headerButton && (
              <ButtonTooltip
                content={headerButton.title}
                disabled={headerButton.disabled}
                position="bottom"
              >
                <Button
                  type={ButtonType.primary}
                  disabled={headerButton.disabled}
                  onClick={headerButton.onClick}
                >
                  {headerButton.label}
                </Button>
              </ButtonTooltip>
            )}
          </div>
        </div>
      )}
      {intro && (
        <p className="mb-12" dangerouslySetInnerHTML={{ __html: intro }}></p>
      )}

      {props.children}
    </div>
  )
}

export default Page
